import React from 'react'
import { ShortCenteredTextView, TitleSubSection } from '../Common'
import { Text, Link } from '@aws-amplify/ui-react'


export function Instructions() {
    return <ShortCenteredTextView>
        <TitleSubSection>Vpn Creation Steps</TitleSubSection>
        <ol style={{ marginTop: '-1em' }} start={0}>
            <li>Check you've <Link href="https://wireguard.com/install">WireGuard</Link> installed,
                and enough <Link href='/pricing'>peanuts</Link>;</li>
            <li>Create a vpn in the <Link href='#locations'>location</Link> you want below;</li>
            <li>Download your vpn configuration, and connect to it;</li>
            <li>Delete your vpn when done.</li>
        </ol>

        <Text marginTop={'-1.5em'} marginBottom={'1.25em'} fontSize={'smaller'}>
            See the <Link href='/faq#connection'>FAQ</Link> for more detailed instructions.
        </Text>
    </ShortCenteredTextView >
}



